const keys = {
    GET_MENTORS: '/mentors',
    GET_TICKETS: '/tickets',
    GET_TICKET_SINGLE: (id: string) => `/tickets/${id}`,
    GET_TICKET_CATEGORIES: `/ticket-categories`,
    POST_TICKET_COMPOSE: '/tickets', // title , ticket_category_id , description , attachment
    POST_TICKET_COMPOSE_ANSWER: (id: string) => `/ticket-answer/${id}` // description , attachment
};

export default keys;

